<template>
   <f7-page name="401">
    <div class="content">
        <img src="/static/images/icons/custom/sad-smile.svg" alt="sad smile">
        <h1>401</h1>
        <p>You are not authorized to access</p>
    </div>
  </f7-page>
</template>

<script>
export default {
  name: 'unauthorized'
}
</script>

<style scoped>
.page{
    background-color: #2C61D5;
    color: #fff;
}

.navbar-container{
    background-color: #fff;
}

.content > img {
    max-width: 110px;
    margin-bottom: 48px;
    opacity: 0.1;
}

.content {
    width: 100%;
    height: 100%;
    max-width: 788px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 102px 10% 30px;
    text-align: center;
}

.content > h1 {
    font-weight: 700;
    font-size: 44px;
    color: inherit;
}

.content > p {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// 401.vue?5d5edf2f